import {
  Box, Button, IconButton, MenuItem, TextField
} from "@mui/material";
import { downloadSalaryPDF } from "../others/SalarySlipPDF";
import { useEffect, useState } from "react";
import SalarySlip from "../reciept/SalarySlip";
import { useRef } from "react";
import authService from "../Auth/AuthService";
import { CurrencyRupee, Search } from "@mui/icons-material";
import PrintIcon from "@mui/icons-material/Print";
import { DownloadIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const months = [
  { label: "January", value: "January" },
  { label: "February", value: "February" },
  { label: "March", value: "March" },
  { label: "April", value: "April" },
  { label: "May", value: "May" },
  { label: "June", value: "June" },
  { label: "July", value: "July" },
  { label: "August", value: "August" },
  { label: "September", value: "September" },
  { label: "October", value: "October" },
  { label: "November", value: "November" },
  { label: "December", value: "December" }
];

const SalarySlipPage = ({ empId }) => {

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  const [show, setShow] = useState(true);
  const hasFetched = useRef(false);
  const navigate = useNavigate();
  const [salaryData, setSalaryData] = useState(null);
  const token = authService.tokenInfoNew();
  // const years = Array.from({ length: 7 }, (_, i) => currentYear - 5 + i);
  const years = Array.from({ length: 3 }, (_, i) => currentYear - i);
  const [school, setSchool] = useState({});

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    loadSalarySlip();
    loadSchool();
  }, []);

  const loadSalarySlip = async () => {
    try {
      // GET /api/salary/slip?empId=12&month=March&year=2025
      const url = authService.pathUrl('GET', '/salary/slip?empId=' + `${empId}` + '&month=' + `${month}` + '&year=' + `${year}`);
      const res = await authService.getAuth(url);
      setSalaryData(res);
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  };
  const loadSchool = async () => {
    try {
      const url = authService.pathUrl("GET", "/schools/email");
      const schoolsData = await authService.getAuth(url);
      setSchool(schoolsData);
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  }

  const handleSalary = async () => {
    try {
      const url = authService.pathUrl('POST', '/salary/generate?empId=' + `${empId}` + '&month=' + `${month}` + '&year=' + `${year}`);
      const res = await authService.postAuth(url);
      console.log(res);
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  };

  return (
    <Box>
      {show && (
        <Box display="flex" justifyContent={'center'} gap={2} mb={2}>
          <Button onClick={() => navigate(-1)} sx={{ bgcolor: '#1b1914', color: '#fff' }}>Back</Button>
          {token?.roles === "ADMIN" && (<>
            <TextField
              select
              size="small"
              label="Month"
              value={month}
              onChange={e => setMonth(e.target.value)}
            >
              {months.map(m => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Year"
              size="small"
              value={year}
              onChange={e => setYear(Number(e.target.value))}
            >
              {years.map(y => (
                <MenuItem key={y} value={y}>
                  {y}
                </MenuItem>
              ))}
            </TextField>

            <Button onClick={() => loadSalarySlip()}><Search /></Button>

            <Button
              variant="contained" sx={{ bgcolor: '#1b1914' }}
              title="Generate Salary"
              onClick={() => {
                handleSalary();
              }}
            >
              <CurrencyRupee /> generate
            </Button>
          </>)}
          <Button
            variant="contained" sx={{ bgcolor: '#1b1914' }}
            onClick={() => {
              setShow(false);
              setTimeout(() => {
                window.print();
                setShow(true);
              }, 100);
            }}><PrintIcon /> print</Button>
          <Button
            variant="contained" sx={{ bgcolor: '#1b1914' }}
            onClick={() =>
              downloadSalaryPDF("salary-slip", "SalarySlip.pdf")
            }
          >
            <DownloadIcon fontSize="large" />pdf
          </Button>
        </Box>
      )}
      <Box id="salary-slip">
        <SalarySlip data={{ ...salaryData, ...school }} />
      </Box>
    </Box>
  );
};

export default SalarySlipPage;
